import { atom } from "recoil";
import { User } from "shared/interfaces/user";

const userState = atom<User | null>({ key: "UserSate", default: null });
export { userState };
